/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled, { css } from 'styled-components';
import { Media }       from '../../../styles/utilities';
import { Spacing }     from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledPictureWithText = styled.div`
  display: flex;
  flex-flow: column;
  > *:nth-child(1) {
    padding: 0 0 ${Spacing.Small} 0;
  }
  ${Media.Tablet`{
    flex-flow: row;
    align-items: center;
    > * {
    flex: 1;
    }
    > *:nth-child(1) {
      margin-right: 30px;
    }
    > *,
    > *:nth-child(1) {
      padding: ${Spacing.Small} 0;
    }
    ${props => props.direction && css`
      flex-direction: ${props.direction};
      > *:nth-child(1) {
        margin-right: 0;
      }
      > *:nth-child(2) {
        margin-right: 30px;
      }
    `}
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledPictureWithText/index.js